import { mergeAttributes, Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-3";

import Component from "./FormulaInlineComponent.vue";

export interface FormulaInlineOptions {
  content: string;
}
declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    formulaInline: {
      addKatexInline: (_options: { content: string }) => ReturnType;
    };
  }
}

export default Node.create<FormulaInlineOptions>({
  name: "formula-inline",

  group: "inline",

  inline: true,

  selectable: true,

  atom: true,

  editable: false,

  addOptions() {
    return {
      content: "",
    };
  },

  addAttributes() {
    return {
      content: {
        default: "",
        renderHTML: (attributes) => {
          return {
            content: attributes.content,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "katex-inline",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["katex-inline", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return VueNodeViewRenderer(Component);
  },

  addCommands() {
    return {
      addKatexInline:
        (_options: { content: string }) =>
        ({ state, commands }) => {
          const { selection } = state;
          const contentNode = [
            {
              type: "formula-inline",
              attrs: { content: "x^2 + y^2 = z^2" },
            },
          ];
          commands.insertContentAt(selection.from, contentNode, {
            updateSelection: true,
          });
          return true;
        },
    };
  },
});
